import { SET_VALUE_ROUTING } from '../../../actions/travelSs/routing';
import { routingRules } from './routing';

import {
    TRAVEL_SS_INSURANCE_FORM_SET_VALID,
    TRAVEL_SS_INSURANCE_FORM_SET_VALUE,
    SET_SHARE_EMAIL_VALID,
    SET_SHARE_EMAIL_VALUE,
} from '../../../actions/travelSs/quote';
import { quoteFormRules } from './quote';

import {
    TRAVEL_INSURANCE_SS_TRAVEL_DETAILS_FORM_SET_VALID,
    TRAVEL_INSURANCE_SS_TRAVEL_DETAILS_FORM_SET_VALUE,
} from '../../../actions/travelSs/travelDetails';
import { travelDetailsFormRules } from './travelDetails';

import {
    TRAVEL_SS_EMPLOYEE_DETAILS_FORM_SET_VALUE,
    TRAVEL_SS_EMPLOYEE_DETAILS_FORM_SET_VALID,
} from '../../../actions/travelSs/employeeDetails';
import { employeeDetailsFormRules } from './employeeDetails';

import {
    TRAVEL_SS_NEXT_OF_KIN_FORM_SET_VALID,
    TRAVEL_SS_NEXT_OF_KIN_FORM_SET_VALUE,
} from '../../../actions/travelSs/nextOfKin';
import { nextOfKinFormRules } from './nextOfKin';

import {
    TRAVEL_SS_AGENT_MODAL_DETAILS_SET_VALUE,
    TRAVEL_SS_AGENT_MODAL_DETAILS_SET_VALID,
} from '../../../actions/travelSs/agentModal';
import { agentModalFormRules } from './agentModal';

import { PAYMENTS_SET_VALID, PAYMENTS_SET_VALUE } from '../../../actions/travelSs/payments';
import { paymentsFormRules } from './payments';
import { shareQuoteFormRules } from './shareQuote';

export const travelSsInsuranceRules = (store, next, action) => {
    if (action.type.startsWith(SET_VALUE_ROUTING)) {
        return routingRules(store, next, action);
    }

    if (
        action.type.startsWith(TRAVEL_SS_INSURANCE_FORM_SET_VALUE) ||
        action.type.startsWith(TRAVEL_SS_INSURANCE_FORM_SET_VALID)
    ) {
        return quoteFormRules(store, next, action);
    }

    if (
        action.type.startsWith(TRAVEL_INSURANCE_SS_TRAVEL_DETAILS_FORM_SET_VALUE) ||
        action.type.startsWith(TRAVEL_INSURANCE_SS_TRAVEL_DETAILS_FORM_SET_VALID)
    ) {
        return travelDetailsFormRules(store, next, action);
    }

    if (
        action.type.startsWith(TRAVEL_SS_EMPLOYEE_DETAILS_FORM_SET_VALUE) ||
        action.type.startsWith(TRAVEL_SS_EMPLOYEE_DETAILS_FORM_SET_VALID)
    ) {
        return employeeDetailsFormRules(store, next, action);
    }

    if (
        action.type.startsWith(TRAVEL_SS_NEXT_OF_KIN_FORM_SET_VALUE) ||
        action.type.startsWith(TRAVEL_SS_NEXT_OF_KIN_FORM_SET_VALID)
    ) {
        return nextOfKinFormRules(store, next, action);
    }

    if (
        action.type.startsWith(TRAVEL_SS_AGENT_MODAL_DETAILS_SET_VALUE) ||
        action.type.startsWith(TRAVEL_SS_AGENT_MODAL_DETAILS_SET_VALID)
    ) {
        return agentModalFormRules(store, next, action);
    }

    if (action.type.startsWith(PAYMENTS_SET_VALUE) || action.type.startsWith(PAYMENTS_SET_VALID)) {
        return paymentsFormRules(store, next, action);
    }

    if (action.type.startsWith(SET_SHARE_EMAIL_VALUE) || action.type.startsWith(SET_SHARE_EMAIL_VALID)) {
        return shareQuoteFormRules(store, next, action);
    }

    return null;
};
